'use client'

import { Loader } from '@vinted/web-ui'

const FilterLoader = () => (
  <div className="u-flexbox u-justify-content-center u-ui-padding-vertical-x3-large">
    <Loader testId="catalog-filter-loader" />
  </div>
)

export default FilterLoader
